import React, { Component } from 'react';
import { Row, Col, DropdownButton, Dropdown } from 'react-bootstrap';
import Clndr from './CalendarComponent';
import { Line } from "react-chartjs-2";

class AdminDashboard extends Component{
    constructor(props){
        super(props);
    }
    render(){
        let chartData = {
            labels: [
              "03",
              "05",
              "07",
              "9",
              "11",
              "13",
              "15",
              "17",
              "19",
              "21",
              "23",
              "25",
              "27",
              "29",
              "31",
            ],
            datasets: [
              {
                label: "",
                data: [
                  2,
                  3,
                  4,
                  1,
                  5,
                  1,
                  4,
                  2,
                  3,
                  4,
                  1,
                  5,
                  1,
                  4,
                  2,
                  3,
                  4,
                  1,
                  5,
                  1,
                  4,
                  2,
                  3,
                  4,
                  1,
                  5,
                  1,
                  4,
                  2,
                  3,
                  4,
                ],
                borderColor: "#108bc9",
                backgroundColor: "#108bc9",
                fill: false,
                pointRadius: 3,
                pointHoverRadius: 4,
                borderWidth: 2,
                height: "20px"
              },
            ],
          };
       return(
        <div className="container admin-dashboard">
            <Row className="top-row">
                <Col lg={3} md={3} sm={6} xs={6} className="btm-col-mrgn">
                    <div className="upper-row">
                        <div>
                            <p className="m-0 head-num">0</p>
                            <p className="m-0 body-text">Student</p>
                        </div>
                        <div className="fa-user-img"><span className="fa fa-user fa-lg"></span></div>
                    </div>
                </Col>
                <Col lg={3} md={3} sm={6} xs={6} className="btm-col-mrgn">
                    <div className="upper-row">
                        <div>
                            <p className="m-0 head-num">0</p>
                            <p className="m-0 body-text">Tutor</p>
                        </div>
                        <div className="fa-user-img"><span className="fa fa-user fa-lg"></span></div>
                    </div>
                </Col>
                <Col lg={3} md={3} sm={6} xs={6} className="btm-col-mrgn">
                    <div className="upper-row">
                        <div>
                            <p className="m-0 head-num">0</p>
                            <p className="m-0 body-text">Course</p>
                        </div>
                        <div className="fa-user-img"><span className="fa fa-user fa-lg"></span></div>
                    </div>
                </Col>
                <Col lg={3} md={3} sm={6} xs={6} className="btm-col-mrgn">
                    <div className="upper-row">
                        <div>
                            <p className="m-0 head-num">£0.00</p>
                            <p className="m-0 body-text">Revenue</p>
                        </div>
                        <div className="fa-user-img"><span className="fa fa-lg" style={{ fontWeight: "bolder" }}>£</span></div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col lg={8} md={8} sm={12} xs={12} className="btm-col-mrgn">
                    <div className="graph-col">
                        <div className="flex-btw">
                            <div className="head-line-font d-flex justify-flex-center"><p>INCOME & EXPENSE</p></div>
                            <DropdownButton
                                id="dropdown-basic-button"
                                className="dropdown"
                                title={
                                    <span className="flex-between-center">
                                        <span className="search-date">
                                            <p className="m-0">Last 6 months <span className="arrow-style">⯆</span></p>
                                        </span>
                                    </span>
                                }
                                >
                            </DropdownButton>
                        </div>
                        <div className="d-flex " style={{alignItems: "center"}}>
                            <div className="pattern-color-dark"></div>
                            <span className="pattern-color-font">Total Income</span>
                            <div className="pattern-color-light"></div>
                            <span className="pattern-color-font">Total Expense</span>
                        </div>
                        <span className="income-pound">£ 75,000</span>
                        <span className="exp-pound">£ 15,000</span>
                        <Line data={chartData} />
                    </div>
                </Col>
                <Col lg={4} md={4} sm={12} xs={12} className="btm-col-mrgn">
                    <div className="clndr-col">
                        <p className="head-line-font">EVENT CALENDER</p>
                        <Clndr />
                    </div>
                </Col>
            </Row>
            <Row>
                 <Col lg={8} md={8} sm={12} xs={12}>
                 <div className="userinfo">
                     <h3>New Users</h3>
                     <div>
                         No new users
                     </div>
                     <div className="settingspace">
                        <span>
                            Show <input type="number"/> entries
                        </span>
                        <DropdownButton
                                    id="dropdown-basic-button"
                                    className="dropdown"
                                    title={
                                        <span className="flex-between-center">
                                            <span className="search-date">
                                                <p className="m-0">Last 6 months <span className="arrow-style">⯆</span></p>
                                            </span>
                                        </span>
                                    }
                                    >
                        </DropdownButton>
                     </div>

                    <div className="table-responsive">
                        
                   
                     <table>
                        <tr>
                            <th>Image</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Town or City</th>
                            <th>Status</th>
                        </tr>
                        <tr>
                            <td><img src={require("./../../assets/images/avator.png")} alt="Avatar" class="avatar"/></td>
                            <td>Thomas k.</td>
                            <td>thomas@yahoo.com</td>
                            <td>London, UK</td>
                            <td className="activecolor">Active</td>
                        </tr>
                        <tr>
                            <td><img src={require("./../../assets/images/avator.png")} alt="Avatar" class="avatar"/></td>
                            <td>James J.</td>
                            <td>jamesjack@gmail.com</td>
                            <td>Bristol, UK</td>
                            <td className="ipcolor">In Progress</td>
                        </tr>
                        <tr>
                            <td><img src={require("./../../assets/images/avator.png")} alt="Avatar" class="avatar"/></td>
                            <td>Muhammed Yasik</td>
                            <td>myasik@gmail.com</td>
                            <td>Liverpool, UK</td>
                            <td className="activecolor">Active</td>
                        </tr>
                        <tr>
                            <td><img src={require("./../../assets/images/avator.png")} alt="Avatar" class="avatar"/></td>
                            <td>Thomas k.</td>
                            <td>thomas@yahoo.com</td>
                            <td>Manchester, UK</td>
                            <td className="activecolor">Active</td>
                        </tr>
                        <tr>
                            <td><img src={require("./../../assets/images/avator.png")} alt="Avatar" class="avatar"/></td>
                            <td>James J.</td>
                            <td>jamesjack@gmail.com</td>
                            <td>London, UK</td>
                            <td className="ipcolor">In Progress</td>
                        </tr>
                        <tr>
                            <td><img src={require("./../../assets/images/avator.png")} alt="Avatar" class="avatar"/></td>
                            <td>Muhammed Yasik</td>
                            <td>myasik3@gmail.com</td>
                            <td>Manchester, UK</td>
                            <td className="ipcolor">In Progress</td>
                        </tr>
                        <tr>
                            <td><img src={require("./../../assets/images/avator.png")} alt="Avatar" class="avatar"/></td>
                            <td>Thomas k.</td>
                            <td>thomas@yahoo.com</td>
                            <td>Liverpool, UK</td>
                            <td className="activecolor">Active</td>
                        </tr>
                    </table>
                   
                    </div>
                    <nav aria-label="Page navigation example ">
                        <ul class="pagination table-responsive">
                            <span className="goto-div">Go to </span>
                            <li class="goto-div"><button className="buttonsetting">1</button></li>
                            <li class="page-item "><a class="page-link fa fa-angle-left" href="#"></a></li>
                            <li class="page-item active"><a class="page-link" href="#">1</a></li>
                            <li class="page-item"><a class="page-link" href="#">2</a></li>
                            <li class="page-item"><a class="page-link" href="#">3</a></li>
                            <li class="page-item"><a class="page-link" href="#">4</a></li>
                            <li class="page-item"><a class="page-link" href="#">5</a></li>
                            <li class="page-item"><a class="page-link" href="#">6</a></li>
                            <li class="page-item"><a class="page-link threedots" href="#">...</a></li>
                            <li class="page-item"><a class="page-link" href="#">7</a></li>
                            <li class="page-item"><a class="page-link" href="#">8</a></li>
                            <li class="page-item "><a class="page-link fa fa-angle-right" href="#"></a></li>
                            <li class="page-item "><a class="page-link fitwidth" href="#">15/page <span className="fa fa-caret-down"></span></a></li>
                            <span className="goto-div">110 results</span>
                      </ul>

                    </nav>
                 </div>

                </Col>
                <Col lg={4} md={4} sm={12} xs={12}>
                 <div className="recent">
                     <h3><span className="recentactivity">RECENT ACTIVITY</span><span>See all</span></h3>
                     <div>
                         No recent activities
                     </div>

                    <div className="list">
                     <div class="listingdata">                         
                         THOMAS K                                     <span>5 mins ago</span>
                         <p>Iste minus et. Non necessitatibus ut est est id amet. Officiis 
                        sequi dolorum assumenda s</p>
                     </div>
                     <div class="listingdata">                         
                         THOMAS K                                     <span>5 mins ago</span>
                         <p>Iste minus et. Non necessitatibus ut est est id amet. Officiis 
                        sequi dolorum assumenda s</p>
                     </div>
                     <div class="listingdata">                         
                         THOMAS K                                     <span>5 mins ago</span>
                         <p>Iste minus et. Non necessitatibus ut est est id amet. Officiis 
                        sequi dolorum assumenda s</p>
                     </div>
                     <div class="listingdata">                         
                         THOMAS K                                     <span>5 mins ago</span>
                         <p>Iste minus et. Non necessitatibus ut est est id amet. Officiis 
                        sequi dolorum assumenda s</p>
                     </div>
                     <div class="listingdata">                         
                         THOMAS K                                     <span>5 mins ago</span>
                         <p>Iste minus et. Non necessitatibus ut est est id amet. Officiis 
                        sequi dolorum assumenda s</p>
                     </div>
                     <div class="listingdata">                         
                         THOMAS K                                     <span>5 mins ago</span>
                         <p>Iste minus et. Non necessitatibus ut est est id amet. Officiis 
                        sequi dolorum assumenda s</p>
                     </div>
                     <div class="listingdata">                         
                         THOMAS K                                     <span>5 mins ago</span>
                         <p>Iste minus et. Non necessitatibus ut est est id amet. Officiis 
                        sequi dolorum assumenda s</p>
                     </div>
                     <div class="listingdata">                         
                         THOMAS K                                     <span>5 mins ago</span>
                         <p>Iste minus et. Non necessitatibus ut est est id amet. Officiis 
                        sequi dolorum assumenda s</p>
                     </div>
                     <div class="listingdata">                         
                         THOMAS K                                     <span>5 mins ago</span>
                         <p>Iste minus et. Non necessitatibus ut est est id amet. Officiis 
                        sequi dolorum assumenda s</p>
                     </div>
                     <div class="listingdata">                         
                         THOMAS K                                     <span>5 mins ago</span>
                         <p>Iste minus et. Non necessitatibus ut est est id amet. Officiis 
                        sequi dolorum assumenda s</p>
                     </div>
                     <div class="listingdata">                         
                         THOMAS K                                     <span>5 mins ago</span>
                         <p>Iste minus et. Non necessitatibus ut est est id amet. Officiis 
                        sequi dolorum assumenda s</p>
                     </div>
                     <div class="listingdata">                         
                         THOMAS K                                     <span>5 mins ago</span>
                         <p>Iste minus et. Non necessitatibus ut est est id amet. Officiis 
                        sequi dolorum assumenda s</p>
                     </div>
                     </div>
                 </div>
                 <div className="birthday">
                     <h3><span className="birthdays">BIRTHDAYS</span><span>See all</span></h3>
                     <div>
                         No birthdays
                     </div>
                    <div className="birthdayimages">
                        <div>
                        <img src={require("./../../assets/images/avator.png")} alt="Avatar" class="avatar"/>
                        <h6>
                            Ahmad
                        </h6>
                        <span>
                            profile
                        </span>
                        </div>

                        <div>
                        <img src={require("./../../assets/images/avator.png")} alt="Avatar" class="avatar"/>
                        <h6>
                            Ahmad
                        </h6>
                        <span>
                            profile
                        </span>
                        </div>

                        <div>
                        <img src={require("./../../assets/images/avator.png")} alt="Avatar" class="avatar"/>
                        <h6>
                            Ahmad
                        </h6>
                        <span>
                            profile
                        </span>
                        </div>

                        <div>
                        <img src={require("./../../assets/images/avator.png")} alt="Avatar" class="avatar"/>
                        <h6>
                            Ahmad
                        </h6>
                        <span>
                            profile
                        </span>
                        </div>

                        

                        
                    </div>
                    </div>
                 </Col>
            </Row>
        </div>
       );
    }
}

export default AdminDashboard;